

import { withStyles } from "@material-ui/core/styles";
import styles from "../OperationsStyles";

// import FandO from "../F&O/FAndO";
import Nominations from '../Nomination/Nomination'
// import RegPaymenlist from "../../RegPaymentList/RegPaymenlist"; // srini - 05/06/25
// import LearningCentre from '../../LearningCentre/LearningCentre' // srini - 05/06/25
import BankVerifictaion from "../BankVerification/BankVerifictaion"; 

import { Grid, Tab, Tabs, Typography } from "@mui/material";
import AccountClosure from "../AccountClousre/AccountClosure";
import Fno from "../Fno/fno";
import DDPI from "../DDPI/DDPI";
import UserProfile from "../UserProfile.js/UserProfile";


const MainTabLayout = ({ classes, tabId, handleTabChange,nomineeList, fnoList,acList, userList,bankList, ddpilist }) => {
 
  

  return (
    <div style={{ flex: "82%" }}>
      <Typography
        className={classes.dashboardText2}
        style={{ color: "#FFFFFF", margin: "7% 0 1% 0" }}
      >
        Operations
      </Typography>
    

      <Grid container alignItems="flex-end">
        <Grid item xs={10}>
          <Tabs
            value={tabId}
            onChange={handleTabChange}
            variant="standard"
            classes={{ indicator: classes.indicator }}
            indicatorColor="primary"
            style={{ margin: "1% 0 0 0" }}
          >
           

            {/* srini - 05/06/25 */}
            {/* <Tab
              value={0}
              className={classes.pending_heading2}
              label="Learning Center"
              style={{
                borderBottom:
                  tabId !== 0 ? "2px solid #131E2E" : "2px solid #F3D45E",
                
              }}
            /> */}
            <Tab
              value={1}
              className={classes.pending_heading2}
               label={`F&O - (${fnoList.length})`} // srini - 18-06-25
              style={{
                borderBottom:
                  tabId !== 1 ? "2px solid #131E2E" : "2px solid #F3D45E",
                
              }}
            />
            <Tab
              value={2}
              className={classes.pending_heading2}
             label={`Nominations - (${nomineeList.length})`} //srini - 18-06-25
              style={{
                borderBottom:
                  tabId !== 2 ? "2px solid #131E2E" : "2px solid #F3D45E",
              }}
            />
            {/* srini - 05/06/25 */}
            {/* <Tab
              value={3}
              className={classes.pending_heading2}
              label="Payments"
              style={{
                borderBottom:
                  tabId !== 3 ? "2px solid #131E2E" : "2px solid #F3D45E",
              }}
            /> */}

             <Tab
              value={3}
              className={classes.pending_heading2}
              label={`User Profile - (${userList.length})`}
              style={{
                borderBottom:
                  tabId !== 3 ? "2px solid #131E2E" : "2px solid #F3D45E",
              }}
            />

             <Tab
              value={4}
              className={classes.pending_heading2}
              label={`Account Closures - (${acList.length})`} //srini - 18-06-25
              style={{
                borderBottom:
                  tabId !== 4 ? "2px solid #131E2E" : "2px solid #F3D45E",
              }}
            />
             <Tab
              value={6}
              className={classes.pending_heading2}
              label={`DDPI - (${ddpilist.length})`}
              style={{
                borderBottom:
                  tabId !== 6 ? "2px solid #131E2E" : "2px solid #F3D45E",
              }}
            />
  {/* ADD BANK srini - 14/07/25 */}
            <Tab
              value={5}
              className={classes.pending_heading2}
              label={`Bank Verification - (${bankList.length})`}
              style={{
                borderBottom:
                  tabId !== 5 ? "2px solid #131E2E" : "2px solid #F3D45E",
              }}
            />
          </Tabs>
        </Grid>
      </Grid>

    

    {/* srini - 05/06/25 */}
      {/* {tabId === 0 && (
        <>
          <LearningCentre />
        </>
      )} */}

   

      {tabId === 1 && (
        <>
       <Fno/>
        </>
      )}

      {tabId === 6 && (
        <>
          <DDPI classes={classes}/>
        </>
      )}
          {/* User Profile srini - 14/07/25 */}
      {tabId === 3 && (
        <UserProfile classes={classes} />
      )}

      {tabId === 2 && (
        <>
          <Nominations />
        </>
      )}
  {/* srini - 05/06/25 */}
      {/* {tabId === 3 && (
        <>
          <RegPaymenlist />
        </>
      )} */}

        {tabId === 4 && (
       <AccountClosure classes={classes}/>
      )}
      {/* ADD BANK srini - 14/07/25 */}
      {tabId === 5 && (
        <BankVerifictaion classes={classes} />
      )}

    </div>
  );
};

export default withStyles(styles)(MainTabLayout);
